import noop from 'lodash/noop';
import classNames from 'classnames';
import React, { PureComponent, PropTypes } from 'react';
import { withStyle } from '../../utils/Decorator';

@withStyle(require('./Button.styl'))
export default class Button extends PureComponent {
  static displayName = 'Button';

  static propTypes = {
    children: PropTypes.node,
    ui: PropTypes.oneOf(['default', 'left', 'left2', 'center', 'right']),
    type: PropTypes.oneOf(['default', 'ui', 'toggle', 'tab', 'tab-c', 'gold', 'jewel', 'discreet', 'share', 'danger']),
    size: PropTypes.oneOf(['default', 'intro']),
    active: PropTypes.bool.isRequired,
    disabled: PropTypes.bool.isRequired,
    grayscale: PropTypes.bool.isRequired,
    onClick: PropTypes.func,
    onTouchStart: PropTypes.func,
  };

  static defaultProps = {
    ui: 'default',
    type: 'default',
    size: 'default',
    active: false,
    disabled: false,
    grayscale: false,
    onClick: noop,
  };

  render = () => {
    const className = classNames('Button', `type-${this.props.type}`, `size-${this.props.size}`, {
      [`ui-${this.props.ui}`]: this.props.ui !== 'default',
      active: this.props.active,
      nonactive: !this.props.active,
      disabled: this.props.disabled,
      grayscale: this.props.grayscale,
    });
    return (
      <div className={className} onClick={this.props.disabled ? noop : this.props.onClick} onTouchStart={this.props.onTouchStart} disabled={this.props.disabled}>
        {this.props.children}
      </div>
    );
  };
}



// WEBPACK FOOTER //
// ./src/app/components/Button/Button.jsx